import { UseCases } from "@planzone/core";
import { Context, Roles } from "@scenes/safeguard/types";
import { PlanzoneSettings } from "@planzone/dto";

function updateFromSettings(
  settings: PlanzoneSettings,
  permissions: { [Key in UseCases]: Roles[] },
  context: Context,
): {
  [Key in UseCases]: Roles[];
} {
  return {
    ...permissions,
    [UseCases.createTask]: settings.canWorkersCreateTask
      ? [...permissions.createTask, Roles.Worker]
      : permissions.createTask,
    [UseCases.createList]: settings.canWorkersCreateList
      ? [...permissions.createList, Roles.Worker]
      : permissions.createList,
    [UseCases.duplicateList]: settings.canWorkersCreateList
      ? [...permissions.duplicateList, Roles.Worker]
      : permissions.duplicateList,
    [UseCases.createEvent]: settings.canWorkersCreateEvent
      ? [...permissions.createEvent, Roles.Worker]
      : permissions.createEvent,
    [UseCases.createMilestone]: settings.canWorkersCreateMilestone
      ? [...permissions.createMilestone, Roles.Worker]
      : permissions.createMilestone,
    [UseCases.editTask]: settings.canWorkersEditTask
      ? [...permissions.editTask, Roles.Worker]
      : permissions.editTask,
    [UseCases.editList]: settings.canWorkersEditList
      ? [...permissions.editList, Roles.Worker]
      : permissions.editList,
    [UseCases.editEvent]: settings.canWorkersEditEvent
      ? [...permissions.editEvent, Roles.Worker]
      : permissions.editEvent,
    [UseCases.editMilestone]: settings.canWorkersEditMilestone
      ? [...permissions.editMilestone, Roles.Worker]
      : permissions.editMilestone,
    [UseCases.removeTask]: settings.canWorkersRemoveTask
      ? [...permissions.removeTask, Roles.Worker]
      : permissions.removeTask,
    [UseCases.removeList]: settings.canWorkersRemoveList
      ? [...permissions.removeList, Roles.Worker]
      : permissions.removeList,
    [UseCases.removeEvent]: settings.canWorkersRemoveEvent
      ? [...permissions.removeEvent, Roles.Worker]
      : permissions.removeEvent,
    [UseCases.removeMilestone]: settings.canWorkersRemoveMilestone
      ? [...permissions.removeMilestone, Roles.Worker]
      : permissions.removeMilestone,
    [UseCases.moveListElement]:
      (settings.canWorkersEditTask && !!context.task) ||
      (settings.canWorkersEditList && !!context.list) ||
      (settings.canWorkersEditMilestone && !!context.milestone) ||
      (settings.canWorkersEditEvent && !!context.event)
        ? [...permissions.moveListElement, Roles.Worker]
        : permissions.moveListElement,
    [UseCases.moveKanbanTask]:
      settings.canWorkersEditTask && !!context.task
        ? [...permissions.moveKanbanTask, Roles.Worker]
        : permissions.moveKanbanTask,
  };
}

export { updateFromSettings };
